export const module = {
  info: {
    name: 'network-server',
    caption: 'network server',
    viewGroup: 'general-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    topSeparator: false,
    caption: 'Network Server',
    icon: 'el-icon-folder',
    routeName: 'module->network-server->create',
    children: [
      {
        caption: 'Create Network Server',
        icon: 'el-icon-plus',
        routeName: 'module->network-server->create'
      },
      {
        caption: 'List Network Servers',
        icon: 'el-icon-more-outline',
        routeName: 'module->network-server->list->page',
        routeParams: { listPage: 1}
      },
      {
        caption: 'Allowed IPs',
        icon: 'el-icon-finished',
        routeName: 'module->network-server->server-ufw-commands'
      },
      {
        caption: 'Clean Operations',
        icon: 'el-icon-sunrise',
        routeName: 'module->network-server->voip-clean-operations'
      },
    ]
  }
}

export default module
